import Header from '../global/header/Header';
import Footer from '../global/footer/Footer';
import { Outlet, useLocation } from 'react-router-dom';
import { useState } from 'react';

function Layout({ showSkip, languages, vkycStatus }) {
  return (
    <>
      <Header showSkip={showSkip} languages={languages} vkycStatus={vkycStatus} />
      <Outlet />
      <Footer />
    </>
  );
}

export default Layout;
